import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-arrow",
  "use": "spr-arrow-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 14\" id=\"spr-arrow\"><defs><path id=\"spr-arrow_a\" d=\"M712 985v-2h12.17l-4.58-4.59L721 977l7 7-7 7-1.41-1.41 4.58-4.59z\" /></defs><use fill=\"#cd9932\" xlink:href=\"#spr-arrow_a\" transform=\"translate(-712 -977)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/arrow.svg
// module id = 243
// module chunks = 0